// eslint-disable-next-line max-classes-per-file
import { Translation } from "@/utils/translation";

export type StandardArgTypes = "string" | "table-structure";

export class StandardArg {
	Value:string = "";
	Name:string = "newArg";
	Type:string = "string";

	public constructor(data?:any){
		if (!data) return;
		this.Value = data.Value;
		this.Name = data.Name;
		this.Type = data.Type;
	}

	public getJSON(){
		return {
			Value: this.Value,
			Name: this.Name,
			Type: this.Type
		};
	}
}

export class ExtraArg {
	Name:string = "newArg";
	Type:string = "";
	Decimals:number = 0;
	FriendlyName:Translation = new Translation();

	public constructor(data?:any){
		if (!data) return;
		this.Name = data.Name;
		this.Type = data.Type;
		this.Decimals = data.Decimals;
		this.FriendlyName = new Translation(data.FriendlyName);
	}

	public getJSON(){
		return {
			Name: this.Name,
			Type: this.Type,
			FriendlyName: this.FriendlyName.getJSON(),
			Decimals: this.Decimals
		};
	}
}

export class Script {
	ID:number = 0;
	Name:string = "New script";
	Content:string = "";
	ScriptType:string = "reportengine-table-builder"
	CreatedBy:string = "";
	LastEditedBy:string = "";
	StandardArgs:StandardArg[] = [];
	ExtraArgs:ExtraArg[] = [];
	Icon:string = "";

	constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Name = data.Name;
		this.Content = data.Content;
		this.ScriptType = data.ScriptType;
		this.CreatedBy = data.CreatedBy;
		this.LastEditedBy = data.LastEditedBy;
		this.Icon = data.Icon;
		this.StandardArgs = ((data.StandardArgs || []) as any[]).map(s=>new StandardArg(s));
		this.ExtraArgs = ((data.ExtraArgs || []) as any[]).map(e=>new ExtraArg(e));
	}

	getJSON(){
		return {
			ID: this.ID,
			Name: this.Name,
			Content: this.Content,
			ScriptType: this.ScriptType,
			CreatedBy: this.CreatedBy,
			LastEditedBy: this.LastEditedBy,
			Icon: this.Icon,
			StandardArgs: this.StandardArgs.map(s=>s.getJSON()),
			ExtraArgs: this.ExtraArgs.map(e=>e.getJSON()),
		};
	}
}


export enum ExtraArgTypes {
	STRING = "string",
	NUMBER = "number",
	DATE = "date",
	BOOL = "bool",
	DATE_RANGE = "dateRange",
	MONTH_RANGE_OR_QUARTER = "monthRangeOrQuarter",
	MONTH_OR_QUARTER = "monthOrQuarter",
	PRODUCT_SKU = "productSku",
	PRODUCT_SKU_LIST = "productSkuList",
	BOOKYEAR = "bookyear",
	CLIENT_ID_LIST = "clientIdList",
	SALE_ID_LIST = "saleIdList",
	SUPPLIER_ID_LIST = "supplierIdList",
	PROSPECT_ID_LIST = "prospectIdList",
	CLIENT_ID = "clientId",
	SUPPLIER_ID = "supplierId",
	PROSPECT_ID = "prospectId",
	BANK_TYPE = "bankType",
	PRICE_CATEGORY = "priceCategory"
};

